import type { Filter } from '@/components/table-filters/constants';
import {
  defaultRelationFilter,
  defaultStringFilter,
} from '@/components/table-filters/constants';
import {
  ApartmentQueueConfig,
  RealEstateConfig,
  SegmentConfig,
} from '@pigello/pigello-matrix';

export const apartmentQueueFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: ApartmentQueueConfig.fields.name.verboseName,
    externalFieldName: ApartmentQueueConfig.fields.name.externalFieldName,
  },
  {
    ...defaultRelationFilter,
    title: ApartmentQueueConfig.fields.allowedSegmentForListing.verboseName,
    externalFieldName:
      ApartmentQueueConfig.fields.allowedSegmentForListing.externalFieldName,
    relationModelName: SegmentConfig.modelName,
  },
  {
    ...defaultRelationFilter,
    title:
      ApartmentQueueConfig.fields.requiredRealestatesForEnrollment.verboseName,
    externalFieldName:
      ApartmentQueueConfig.fields.requiredRealestatesForEnrollment
        .externalFieldName,
    relationModelName: RealEstateConfig.modelName,
  },
];
